'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgModify(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ...props },
        React__default.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            React__default.default.createElement("path", { d: "M0 0h16v16H0z" }),
            React__default.default.createElement("path", { d: "M2 2h12v12H2z" }),
            React__default.default.createElement("path", { d: "M2.135 11.375c-.25.492-.092 2.31 0 2.5.091.19 2.082.14 2.498 0C5.048 13.735 12 7.01 12 6.5 12 5.99 9.904 4 9.502 4c-.402 0-7.117 6.882-7.367 7.375zM3.645 13H3v-.645L9.355 6l.645.645L3.645 13zm10.156-9.208l-1.594-1.594A.669.669 0 0011.723 2a.67.67 0 00-.477.198C10.416 2.81 10 3.227 10 3.445 10 3.77 12.318 6 12.554 6c.158 0 .573-.416 1.247-1.247a.679.679 0 000-.96z", fill: "currentColor" }))));
}

module.exports = SvgModify;
//# sourceMappingURL=Modify.js.map
